// extracted by mini-css-extract-plugin
export default {"wrapper":"PrintResults_wrapper__i71sj","printButton":"PrintResults_printButton__0fXHq"};